import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { CountryCode } from '../models/country-code.enum';

interface GlobalPartnerStoreState {
  installerId: string | null;
  installerName: string | null;
  country: CountryCode | null;
}

const initialState: GlobalPartnerStoreState = {
  installerId: null,
  installerName: null,
  country: null,
};

export const GlobalPartnerStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withMethods((store) => ({
    setInstallerInfo(installerId: string, installerName: string): void {
      patchState(store, { installerId, installerName });
    },
    setCountry(country: CountryCode): void {
      patchState(store, { country });
    },
  })),
);
